export default __webpack_public_path__ + "static/datelabel-dropdown-dont-2-light-703bdb609876bc454c3d6fc55462f220.png";